import {Component, ElementRef, Inject, inject, OnInit, ViewChild,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {ProductService} from '../../../../services/product.service';
import {NotificationService} from '../../../../notification/notification.service';
import {CartService} from '../../../../services/cart.service';
import {Router} from '@angular/router';
import {NotificationType} from '../../../../enum/notification-type.enum';
import {
  DetailsProductMenusComponent
} from '../../../../welcome/menus/details-menus/details-product-menus/details-product-menus.component';
import {PromoCartBottomSheetComponent} from './promo-cart-bottom-sheet/promo-cart-bottom-sheet.component';
import {THEME_CONFIG} from '../../../../../environments/tokens/theme.token';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {DecimalPipe, NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-promo-product-offer-dialog',
  templateUrl: './promo-product-offer-dialog.component.html',
  styleUrl: './promo-product-offer-dialog.component.scss',
  imports: [MatIcon, MatButton, DecimalPipe, NgOptimizedImage],
  standalone: true
})
export class PromoProductOfferDialogComponent implements OnInit {

  private dialogRef = inject(MatDialogRef<PromoProductOfferDialogComponent>);
  private productService = inject(ProductService);
  private notificationService = inject(NotificationService);
  private cartService = inject(CartService);
  private dialog = inject(MatDialog);
  private bottomSheet = inject(MatBottomSheet);
  private router = inject(Router);
  protected readonly themeConfig = inject(THEME_CONFIG)

  promo: any = null;
  @ViewChild('scrollableContent') scrollableContent!: ElementRef<HTMLDivElement>;

  selectedItemQuantities: { [ruleId: string]: { [productId: string]: number } } = {};
  customizedItems: { [productId: string]: { [index: number]: any } } = {};
  customizableItems: { [productId: string]: boolean } = {};
  productRequiredAdditions: { [productId: string]: boolean } = {};
  private fullProductsCache: { [productId: string]: any } = {};

  constructor(@Inject(MAT_DIALOG_DATA) public data: { promotion: any, promoCode: string }) {
    this.promo = data.promotion;
    console.log('code', this.data.promoCode)
    console.log('data', this.promo)
  }

  ngOnInit() {
    if (this.promo?.payload?.rules) {
      this.promo.payload.rules.sort((a: any, b: any) => (a.sortOrder || 0) - (b.sortOrder || 0));
      this.promo.payload.rules.forEach((rule: any) => {
        this.selectedItemQuantities[rule.id] = {};
        rule.products.forEach((product: any) => {
          this.selectedItemQuantities[rule.id][product.id] = 0;
        });
      });
    }
  }

  toggleCartSheet() {
    const ref = this.bottomSheet.open(PromoCartBottomSheetComponent, {
      data: {
        promo: this.promo,
        selectedItemQuantities: this.selectedItemQuantities,
        customizedItems: this.customizedItems,
        customizableItems: this.customizableItems,
        productRequiredAdditions: this.productRequiredAdditions,
        fullProductsCache: this.fullProductsCache,
        parent: this
      },
    });

    ref.afterDismissed().subscribe((result: any) => {
      if (result?.action === 'addToCart') {
        this.addToCart();
      }
      if (result?.customizedItems) {
        this.customizedItems = result.customizedItems;
      }
    });
  }

  private getItemKey(ruleId: string, productId: string): string {
    return `${ruleId}_${productId}`;
  }

  getSizesText(sizes: any[]): string {
    if (!sizes || sizes.length === 0) return '';
    return sizes.map(s => s.name).join(', ');
  }

  getProductPrice(product: any, rule: any): number {
    if (rule?.sizes && rule.sizes.length > 0) {
      const sizeName = rule.sizes[0].name;
      if (product.price && typeof product.price === 'object' && !Array.isArray(product.price)) {
        const priceStr = product.price[sizeName];
        if (priceStr !== undefined) return this.parsePrice(priceStr);
      }
      if (this.fullProductsCache[product.id]) {
        const fullProduct = this.fullProductsCache[product.id];
        const priceEntry = fullProduct.pricePerSizes?.find(
          (entry: any) => entry.size.name === sizeName
        );
        if (priceEntry?.price !== undefined) return Number(priceEntry.price);
      }
    }
    if (product.price !== undefined && product.price !== null) {
      if (typeof product.price === 'number') return product.price;
      if (typeof product.price === 'string') return this.parsePrice(product.price);
    }
    return 0;
  }

  private parsePrice(priceStr: string | number): number {
    if (typeof priceStr === 'number') return priceStr;
    if (!priceStr) return 0;
    const cleaned = priceStr.toString().replace(/€/g, '').replace(/\s/g, '').trim().replace(',', '.');
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }

  hasProductsToBuy(): boolean {
    if (!this.promo?.payload?.rules) return false;
    return this.promo.payload.rules.some((rule: any) => rule.offered === false);
  }

  hasOfferedProducts(): boolean {
    if (!this.promo?.payload?.rules) return false;
    return this.promo.payload.rules.some((rule: any) => rule.offered === true);
  }

  private scrollToNextIncompleteRule(completedRuleId: string) {
    setTimeout(() => {
      const rules = this.promo?.payload?.rules || [];
      const currentIndex = rules.findIndex((r: any) => r.id === completedRuleId);

      if (currentIndex === -1) return;

      for (let i = currentIndex + 1; i < rules.length; i++) {
        const rule = rules[i];
        const totalSelected = this.getTotalQuantityForRule(rule.id);

        if (totalSelected < rule.quantity) {
          const nextElement = document.querySelector(`[data-rule-id="${rule.id}"]`);
          if (nextElement) {
            nextElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
          return;
        }
      }

      const scrollContainer = document.querySelector('.overflow-y-auto');
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 250);
  }

  incrementItem(ruleId: string, productId: string, ruleIndex?: number) {
    if (!this.selectedItemQuantities[ruleId]) this.selectedItemQuantities[ruleId] = {};
    if (!this.selectedItemQuantities[ruleId][productId]) this.selectedItemQuantities[ruleId][productId] = 0;

    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    if (rule) {
      const totalQty = this.getTotalQuantityForRule(ruleId);
      if (totalQty >= rule.quantity) {
        const categoryName = rule.category?.name || 'cette catégorie';
        this.notificationService.sendNotification(
          NotificationType.WARNING,
          `Vous avez déjà sélectionné votre "${categoryName}" (${rule.quantity} max)`,
          ''
        );
        return;
      }
    }
    this.selectedItemQuantities[ruleId][productId]++;
    const newTotalQty = this.getTotalQuantityForRule(ruleId);
    if (newTotalQty === rule.quantity) {
      this.scrollToNextIncompleteRule(ruleId);
    }
    this.checkIfCustomizableAndHandleIncrement(ruleId, productId, ruleIndex);
  }

  private checkIfCustomizableAndHandleIncrement(ruleId: string, itemId: string, ruleIndex?: number) {
    const itemKey = this.getItemKey(ruleId, itemId);
    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    if (!rule) return;

    const newTotalQty = this.getTotalQuantityForRule(ruleId);
    const isRuleComplete = newTotalQty === rule.quantity;

    let selectedSize: string | null = null;
    if (rule?.sizes && rule.sizes.length > 0) selectedSize = rule.sizes[0].name;

    if (this.customizableItems[itemKey] !== undefined) {
      const hasRequired = this.productRequiredAdditions[itemKey];
      if (hasRequired) {
        const currentItemQty = this.selectedItemQuantities[ruleId]?.[itemId] || 0;
        const newItemIndex = currentItemQty - 1;
        const cachedProduct = this.fullProductsCache[itemId];
        if (cachedProduct) {
          setTimeout(() => {
            this.openProductCustomizationWithRuleCompletion(cachedProduct, ruleId, newItemIndex, isRuleComplete, ruleIndex);
          }, 100);
        } else {
          this.productService.getProductById(itemId).subscribe({
            next: (res: any) => {
              const product = res.body?.data;
              this.fullProductsCache[itemId] = product;
              setTimeout(() => {
                this.openProductCustomizationWithRuleCompletion(product, ruleId, newItemIndex, isRuleComplete, ruleIndex);
              }, 100);
            }
          });
        }
      }
      return;
    }

    if (this.fullProductsCache[itemId]) {
      const product = this.fullProductsCache[itemId];
      const filteredAdditions = this.getFilteredAdditionsForProduct(product?.additions || [], selectedSize);
      const hasRequiredAdditions = filteredAdditions.some((add: any) => add.required);
      const isCustomizable = product?.additions?.length > 0 || product?.ingredients?.length > 0 || product?.supplements?.length > 0;
      this.customizableItems[itemKey] = isCustomizable;
      this.productRequiredAdditions[itemKey] = hasRequiredAdditions;
      if (hasRequiredAdditions) {
        const currentItemQty = this.selectedItemQuantities[ruleId]?.[itemId] || 0;
        for (let i = 0; i < currentItemQty; i++) {
          const isLastItem = i === currentItemQty - 1;
          setTimeout(() => {
            this.openProductCustomizationWithRuleCompletion(product, ruleId, i, isRuleComplete && isLastItem, ruleIndex);
          }, i * 100);
        }
      }
      return;
    }

    this.productService.getProductById(itemId).subscribe({
      next: (res: any) => {
        const product = res.body?.data;
        this.fullProductsCache[itemId] = product;
        const isCustomizable = product?.additions?.length > 0 || product?.ingredients?.length > 0 || product?.supplements?.length > 0;
        const filteredAdditions = this.getFilteredAdditionsForProduct(product?.additions || [], selectedSize);
        const hasRequiredAdditions = filteredAdditions.some((add: any) => add.required);
        this.customizableItems[itemKey] = isCustomizable;
        this.productRequiredAdditions[itemKey] = hasRequiredAdditions;
        if (hasRequiredAdditions) {
          const currentItemQty = this.selectedItemQuantities[ruleId]?.[itemId] || 0;
          for (let i = 0; i < currentItemQty; i++) {
            const isLastItem = i === currentItemQty - 1;
            setTimeout(() => {
              this.openProductCustomizationWithRuleCompletion(product, ruleId, i, isRuleComplete && isLastItem, ruleIndex);
            }, i * 100);
          }
        }
      },
      error: () => {
        this.customizableItems[itemKey] = false;
        this.productRequiredAdditions[itemKey] = false;
      }
    });
  }

  private openProductCustomizationWithRuleCompletion(product: any, ruleId: string, index: number, isRuleComplete: boolean, ruleIndex?: number) {
    const itemKey = this.getItemKey(ruleId, product.id);
    const existingCustomization = this.customizedItems[itemKey]?.[index];
    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    let selectedSize: string | null = null;
    if (rule?.sizes && rule.sizes.length > 0) selectedSize = rule.sizes[0].name;

    this.bottomSheet.dismiss();

    const dialogRef = this.dialog.open(DetailsProductMenusComponent, {
      width: '95%',
      maxWidth: '600px',
      panelClass: 'custom-dialog',
      restoreFocus: false,
      autoFocus: false,
      data: {productId: product.id, product, existingCustomization, preselectedSize: selectedSize}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.customizedItems[itemKey]) this.customizedItems[itemKey] = {};
        this.customizedItems[itemKey][index] = result;
      }
    });
  }

  decrementItem(ruleId: string, productId: string) {
    if (!this.selectedItemQuantities[ruleId]?.[productId]) return;
    this.selectedItemQuantities[ruleId][productId]--;
    if (this.selectedItemQuantities[ruleId][productId] <= 0) {
      this.selectedItemQuantities[ruleId][productId] = 0;
      const itemKey = this.getItemKey(ruleId, productId);
      if (this.customizedItems[itemKey]) delete this.customizedItems[itemKey];
    }
  }

  getItemQuantity(ruleId: string, productId: string): number {
    return this.selectedItemQuantities[ruleId]?.[productId] || 0;
  }

  getTotalQuantityForRule(ruleId: string): number {
    if (!this.selectedItemQuantities[ruleId]) return 0;
    return Object.values(this.selectedItemQuantities[ruleId]).reduce((sum: number, qty: number) => sum + qty, 0);
  }

  private getAllSelectedItemsFlat(): Array<{ product: any, rule: any, price: number }> {
    if (!this.promo?.payload?.rules) return [];

    const allItems: Array<{ product: any, rule: any, price: number }> = [];

    this.promo.payload.rules.forEach((rule: any) => {
      rule.products.forEach((product: any) => {
        const qty = this.getItemQuantity(rule.id, product.id);
        for (let i = 0; i < qty; i++) {
          allItems.push({
            product,
            rule,
            price: this.getProductBasePrice(product, rule)
          });
        }
      });
    });

    return allItems;
  }

  private getTotalOfferedQuantity(): number {
    if (!this.promo?.payload?.rules) return 0;
    return this.promo.payload.rules
      .filter((r: any) => r.offered)
      .reduce((sum: number, r: any) => sum + r.quantity, 0);
  }

  getSelectedBuyItems(): Array<{ product: any; quantity: number; rule: any }> {
    if (!this.promo?.payload?.rules) return [];

    if (!this.promo.payload.cheapestOffered) {
      const items: Array<{ product: any; quantity: number; rule: any }> = [];
      this.promo.payload.rules.forEach((rule: any) => {
        if (!rule.offered) {
          rule.products.forEach((product: any) => {
            const qty = this.getItemQuantity(rule.id, product.id);
            if (qty > 0) items.push({product, quantity: qty, rule});
          });
        }
      });
      return items;
    }

    const allFlat = this.getAllSelectedItemsFlat();
    if (allFlat.length === 0) return [];

    const sorted = [...allFlat].sort((a, b) => a.price - b.price);
    const offeredCount = this.getTotalOfferedQuantity();
    const buyItems = sorted.slice(offeredCount);

    const grouped = new Map<string, { product: any, quantity: number, rule: any }>();
    buyItems.forEach(item => {
      const key = `${item.rule.id}_${item.product.id}`;
      if (grouped.has(key)) {
        grouped.get(key)!.quantity++;
      } else {
        grouped.set(key, {product: item.product, quantity: 1, rule: item.rule});
      }
    });

    return Array.from(grouped.values());
  }

  getOfferedItems(): Array<{ product: any; quantity: number; rule: any }> {
    if (!this.promo?.payload?.rules) return [];

    if (!this.promo.payload.cheapestOffered) {
      const items: Array<{ product: any; quantity: number; rule: any }> = [];
      this.promo.payload.rules.forEach((rule: any) => {
        if (rule.offered) {
          rule.products.forEach((product: any) => {
            const qty = this.getItemQuantity(rule.id, product.id);
            if (qty > 0) items.push({product, quantity: qty, rule});
          });
        }
      });
      return items;
    }

    const allFlat = this.getAllSelectedItemsFlat();
    if (allFlat.length === 0) return [];

    const sorted = [...allFlat].sort((a, b) => a.price - b.price);
    const offeredCount = this.getTotalOfferedQuantity();
    const offeredItems = sorted.slice(0, offeredCount);

    const grouped = new Map<string, { product: any, quantity: number, rule: any }>();
    offeredItems.forEach(item => {
      const key = `${item.rule.id}_${item.product.id}`;
      if (grouped.has(key)) {
        grouped.get(key)!.quantity++;
      } else {
        grouped.set(key, {product: item.product, quantity: 1, rule: item.rule});
      }
    });

    return Array.from(grouped.values());
  }

  private isProductInOfferedGroup(ruleId: string, productId: string): boolean {
    if (!this.promo?.payload?.cheapestOffered) return false;
    const offeredItems = this.getOfferedItems();
    return offeredItems.some(item => item.rule.id === ruleId && item.product.id === productId);
  }

  openProductCustomizationFromSheet(product: any, ruleId: string, index: number = 0, onDone?: () => void) {
    const itemKey = this.getItemKey(ruleId, product.id);
    const existingCustomization = this.customizedItems[itemKey]?.[index];
    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    let selectedSize: string | null = null;
    if (rule?.sizes && rule.sizes.length > 0) selectedSize = rule.sizes[0].name;
    const cachedProduct = this.fullProductsCache[product.id];

    const dialogRef = this.dialog.open(DetailsProductMenusComponent, {
      width: '95%',
      maxWidth: '600px',
      panelClass: 'custom-dialog',
      restoreFocus: false,
      autoFocus: false,
      data: {
        productId: product.id,
        existingCustomization,
        product: cachedProduct || product,
        preselectedSize: selectedSize
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.customizedItems[itemKey]) this.customizedItems[itemKey] = {};
        this.customizedItems[itemKey][index] = result;
      }
      if (onDone) onDone();
    });
  }

  openProductCustomization(product: any, ruleId: string, index: number = 0) {
    const itemKey = this.getItemKey(ruleId, product.id);
    const existingCustomization = this.customizedItems[itemKey]?.[index];
    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    let selectedSize: string | null = null;
    if (rule?.sizes && rule.sizes.length > 0) selectedSize = rule.sizes[0].name;
    const cachedProduct = this.fullProductsCache[product.id];

    this.bottomSheet.dismiss();

    const dialogRef = this.dialog.open(DetailsProductMenusComponent, {
      width: '95%',
      maxWidth: '600px',
      panelClass: 'custom-dialog',
      data: {
        productId: product.id,
        existingCustomization,
        product: cachedProduct || null,
        preselectedSize: selectedSize
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.customizedItems[itemKey]) this.customizedItems[itemKey] = {};
        this.customizedItems[itemKey][index] = result;
      }
    });
  }

  isItemCustomized(ruleId: string, productId: string, index: number = 0): boolean {
    const itemKey = this.getItemKey(ruleId, productId);
    return !!this.customizedItems[itemKey]?.[index];
  }

  hasIncompleteRequiredCustomizations(ruleId: string, productId: string, index: number = 0): boolean {
    const itemKey = this.getItemKey(ruleId, productId);
    if (!this.productRequiredAdditions[itemKey]) return false;
    const customization = this.customizedItems[itemKey]?.[index];
    if (!customization) return true;

    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    let selectedSize: string | null = null;
    if (rule?.sizes && rule.sizes.length > 0) selectedSize = rule.sizes[0].name;

    if (customization?.product?.additions?.length > 0) {
      const filteredAdditions = this.getFilteredAdditionsForProduct(customization.product.additions, selectedSize);
      for (const addition of filteredAdditions) {
        if (addition.required) {
          const totalSelected = this.getTotalSelectedForAddition(customization, addition.id);
          if (totalSelected !== (addition.quantity || 1)) return true;
        }
      }
    }
    return false;
  }

  private getFilteredAdditionsForProduct(additions: any[], selectedSize: string | null): any[] {
    if (!additions || additions.length === 0) return [];
    if (!selectedSize) return additions;
    return additions.filter((addition: any) => {
      if (!addition.sizes || addition.sizes.length === 0) return true;
      return addition.sizes.some((size: any) => size.name === selectedSize);
    });
  }

  getTotalSelectedForAddition(customization: any, additionId: string): number {
    if (!customization.selectedAdditions?.[additionId]) return 0;
    return Object.values(customization.selectedAdditions[additionId] as Record<string, number>)
      .reduce((sum: number, qty: number) => sum + qty, 0);
  }

  getCustomizationSummary(ruleId: string, productId: string, index: number = 0): string {
    const itemKey = this.getItemKey(ruleId, productId);
    const customization = this.customizedItems[itemKey]?.[index];
    if (!customization) return '';

    const rule = this.promo?.payload?.rules.find((r: any) => r.id === ruleId);
    let selectedSize: string | null = null;
    if (rule?.sizes && rule.sizes.length > 0) selectedSize = rule.sizes[0].name;

    const parts: string[] = [];

    if (customization.excludedIngredients?.length > 0) {
      const excludedNames = customization.excludedIngredients
        .map((id: string) => customization.product.ingredients?.find((i: any) => i.id === id)?.name)
        .filter(Boolean).join(', ');
      if (excludedNames) parts.push(`❌ Sans: ${excludedNames}`);
    }

    if (customization.selectedAdditions) {
      const additionParts: string[] = [];
      const filteredAdditions = this.getFilteredAdditionsForProduct(customization.product.additions || [], selectedSize);
      Object.keys(customization.selectedAdditions).forEach(additionId => {
        const addition = filteredAdditions.find((a: any) => a.id === additionId);
        if (addition) {
          Object.keys(customization.selectedAdditions[additionId]).forEach(itemAdditionId => {
            const qty = customization.selectedAdditions[additionId][itemAdditionId];
            if (qty > 0) {
              const addItem = addition.items.find((i: any) => i.id === itemAdditionId);
              if (addItem) additionParts.push(`${addItem.name}${qty > 1 ? ` x${qty}` : ''}`);
            }
          });
        }
      });
      if (additionParts.length > 0) parts.push(`🍽️ Choix: ${additionParts.join(', ')}`);
    }

    if (customization.selectedSupplements && Object.keys(customization.selectedSupplements).length > 0) {
      const supplementDetails: string[] = [];
      let totalSuppPrice = 0;
      Object.keys(customization.selectedSupplements).forEach(suppId => {
        const supplement = customization.product.supplements?.find((s: any) => s.id === suppId);
        if (supplement) {
          const qty = customization.selectedSupplements[suppId] || 1;
          let unitPrice = supplement.price || 0;
          if (customization.selectedSize && supplement.pricePerSizes?.length > 0) {
            const priced = supplement.pricePerSizes.find((ps: any) => ps.size.name === customization.selectedSize);
            if (priced) unitPrice = priced.price;
          }
          const itemTotal = unitPrice * qty;
          totalSuppPrice += itemTotal;
          supplementDetails.push(`${supplement.name}${qty > 1 ? ` x${qty}` : ''} (+${this.truncate2(itemTotal).toFixed(2).replace('.', ',')}€)`);
        }
      });
      if (supplementDetails.length > 0) {
        const totalText = totalSuppPrice > 0 ? ` (${this.truncate2(totalSuppPrice).toFixed(2).replace('.', ',')}€)` : '';
        parts.push(`➕ Suppléments${totalText}: ${supplementDetails.join(', ')}`);
      }
    }

    return parts.join('\n') || '';
  }

  getCustomizationExtraPrice(ruleId: string, productId: string, index: number = 0): number {
    const itemKey = this.getItemKey(ruleId, productId);
    const customization = this.customizedItems[itemKey]?.[index];
    if (!customization) return 0;

    let extraPrice = 0;

    if (customization.selectedAdditions) {
      Object.keys(customization.selectedAdditions).forEach(additionId => {
        const addition = customization.product.additions?.find((a: any) => a.id === additionId);
        if (addition) {
          Object.keys(customization.selectedAdditions[additionId]).forEach(itemAdditionId => {
            const qty = customization.selectedAdditions[additionId][itemAdditionId];
            if (qty > 0) {
              const addItem = addition.items.find((i: any) => i.id === itemAdditionId);
              if (addItem?.price) extraPrice += addItem.price * qty;
            }
          });
        }
      });
    }

    if (customization.selectedSupplements) {
      Object.keys(customization.selectedSupplements).forEach(suppId => {
        const supplement = customization.product.supplements?.find((s: any) => s.id === suppId);
        if (supplement) {
          const qty = customization.selectedSupplements[suppId] || 1;
          let price = supplement.price || 0;
          if (customization.selectedSize && supplement.pricePerSizes?.length > 0) {
            const priceForSize = supplement.pricePerSizes.find((ps: any) => ps.size.name === customization.selectedSize);
            if (priceForSize) price = priceForSize.price;
          }
          extraPrice += price * qty;
        }
      });
    }

    return extraPrice;
  }

  removeItem(ruleId: string, productId: string, index: number = 0) {
    const itemKey = this.getItemKey(ruleId, productId);
    if (this.customizedItems[itemKey]?.[index]) delete this.customizedItems[itemKey][index];
    if (this.selectedItemQuantities[ruleId]?.[productId] > 0) this.selectedItemQuantities[ruleId][productId]--;
  }

  canAddToCart(): boolean {
    if (!this.promo?.payload?.rules) return false;
    const buyRules = this.promo.payload.rules.filter((r: any) => !r.offered);
    const offerRules = this.promo.payload.rules.filter((r: any) => r.offered);

    for (const rule of buyRules) {
      if (this.getTotalQuantityForRule(rule.id) !== rule.quantity) return false;
    }
    for (const rule of offerRules) {
      if (this.getTotalQuantityForRule(rule.id) !== rule.quantity) return false;
    }
    for (const item of this.getSelectedBuyItems()) {
      if (this.hasIncompleteRequiredCustomizations(item.rule.id, item.product.id)) return false;
    }
    for (const item of this.getOfferedItems()) {
      if (this.hasIncompleteRequiredCustomizations(item.rule.id, item.product.id)) return false;
    }
    return true;
  }

  getValidationMessage(): string {
    if (!this.promo?.payload?.rules) return '';
    const buyRules = this.promo.payload.rules.filter((r: any) => !r.offered);
    const offerRules = this.promo.payload.rules.filter((r: any) => r.offered);

    for (const rule of buyRules) {
      const totalSelected = this.getTotalQuantityForRule(rule.id);
      if (totalSelected !== rule.quantity) {
        const remaining = rule.quantity - totalSelected;
        const categoryName = rule.category?.name || 'Produit';
        return `Choisissez "${categoryName}" (${remaining} choix restant${remaining > 1 ? 's' : ''})`;
      }
    }

    if (offerRules.length === 0) return '';

    const totalBought = buyRules.reduce((sum: any, rule: any) => sum + this.getTotalQuantityForRule(rule.id), 0);
    const requiredQty = buyRules.reduce((sum: any, rule: any) => sum + rule.quantity, 0);
    const timesOfferApplies = requiredQty > 0 ? Math.floor(totalBought / requiredQty) : 0;

    if (timesOfferApplies === 0) {
      const firstBuyRule = buyRules[0];
      if (firstBuyRule) {
        const remaining = firstBuyRule.quantity - this.getTotalQuantityForRule(firstBuyRule.id);
        return `Ajoutez ${remaining} "${firstBuyRule.category?.name || 'Produit'}" pour bénéficier des produits offerts`;
      }
      return '';
    }

    for (const rule of offerRules) {
      const totalSelected = this.getTotalQuantityForRule(rule.id);
      const maxAllowed = timesOfferApplies * rule.quantity;
      if (totalSelected !== maxAllowed) {
        const remaining = maxAllowed - totalSelected;
        const categoryName = rule.category?.name || 'Produit offert';
        if (totalSelected === 0) return `Vous pouvez choisir ${maxAllowed} "${categoryName}" offert${maxAllowed > 1 ? 's' : ''}`;
        if (remaining > 0) return `Il vous reste ${remaining} "${categoryName}" offert${remaining > 1 ? 's' : ''} à sélectionner`;
      }
    }
    return '';
  }

  truncate2(value: number): number {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  private getProductBasePrice(product: any, rule: any): number {
    if (!product) return 0;
    const productId = product.id;

    if (this.fullProductsCache[productId]) {
      const fullProduct = this.fullProductsCache[productId];
      if (rule?.sizes && rule.sizes.length > 0 && fullProduct.pricePerSizes?.length > 0) {
        const matchingPrice = fullProduct.pricePerSizes.find((ps: any) => rule.sizes.some((s: any) => s.name === ps.size.name));
        if (matchingPrice) return matchingPrice.price;
      }
      if (fullProduct.price !== undefined && fullProduct.price > 0) return fullProduct.price;
    }

    if (rule?.sizes && rule.sizes.length > 0) {
      if (product.price && typeof product.price === 'object' && !Array.isArray(product.price)) {
        const sizeName = rule.sizes[0].name;
        const priceStr = product.price[sizeName];
        if (priceStr !== undefined) return this.parsePrice(priceStr);
      }
      if (product.pricePerSizes?.length > 0) {
        const matching = product.pricePerSizes.find((ps: any) => rule.sizes.some((s: any) => s.name === ps.size.name));
        if (matching) return matching.price;
      }
    }

    if (product.price !== undefined && product.price !== null) {
      if (typeof product.price === 'number' && product.price > 0) return product.price;
      if (typeof product.price === 'string') return this.parsePrice(product.price);
    }

    return 0;
  }

  getItemBasePriceOnly(ruleId: string, productId: string, index: number = 0): number {
    return this.getProductBasePrice(
      this.promo?.payload?.rules.find((r: any) => r.id === ruleId)?.products.find((p: any) => p.id === productId),
      this.promo?.payload?.rules.find((r: any) => r.id === ruleId)
    );
  }

  getItemSupplementsPriceOnly(ruleId: string, productId: string, index: number = 0): number {
    return this.getCustomizationExtraPrice(ruleId, productId, index);
  }

  getTotalSupplementsPrice(): number {
    let total = 0;
    this.getSelectedBuyItems().forEach(item => {
      for (let i = 0; i < item.quantity; i++) total += this.getItemSupplementsPriceOnly(item.rule.id, item.product.id, i);
    });
    this.getOfferedItems().forEach(item => {
      for (let i = 0; i < item.quantity; i++) total += this.getItemSupplementsPriceOnly(item.rule.id, item.product.id, i);
    });
    return total;
  }

  getTotalBuyItemsPriceWithoutSupplements(): number {
    let total = 0;
    this.getSelectedBuyItems().forEach(item => {
      for (let i = 0; i < item.quantity; i++) total += this.getProductBasePrice(item.product, item.rule);
    });
    return total;
  }

  getTotalOfferedPriceWithoutSupplements(): number {
    let total = 0;
    this.getOfferedItems().forEach(item => {
      for (let i = 0; i < item.quantity; i++) total += this.getProductBasePrice(item.product, item.rule);
    });
    return total;
  }

  shouldInvertCheapestOffered(): boolean {
    return false;
  }

  calculatePromotionTotal(): number {
    const promo = this.promo;
    const reduction = promo?.payload?.reduction;
    const cheapestOffered = promo?.payload?.cheapestOffered;

    const totalBuyBasePrice = this.getTotalBuyItemsPriceWithoutSupplements();
    const totalOfferedBasePrice = this.getTotalOfferedPriceWithoutSupplements();
    const totalSupplements = this.getTotalSupplementsPrice();

    let finalTotal = 0;
    if (!cheapestOffered) {
      if (!reduction) {
        finalTotal = totalBuyBasePrice + totalOfferedBasePrice + totalSupplements;
      } else {
        let newOfferedTotal = totalOfferedBasePrice;
        if (reduction.type === 'PERCENTAGE') {
          newOfferedTotal = totalOfferedBasePrice * (1 - reduction.value);
        } else if (reduction.type === 'FIXED_AMOUNT') {
          newOfferedTotal = Math.max(0, totalOfferedBasePrice - reduction.value);
        } else if (reduction.type === 'SET_PRICE') {
          newOfferedTotal = reduction.value;
        }
        finalTotal = totalBuyBasePrice + newOfferedTotal + totalSupplements;
      }
    } else {
      if (!reduction) {
        finalTotal = totalBuyBasePrice + totalOfferedBasePrice + totalSupplements;
      } else {
        let newOfferedTotal = totalOfferedBasePrice;
        if (reduction.type === 'PERCENTAGE') {
          newOfferedTotal = totalOfferedBasePrice * (1 - reduction.value);
        } else if (reduction.type === 'FIXED_AMOUNT') {
          newOfferedTotal = Math.max(0, totalOfferedBasePrice - reduction.value);
        } else if (reduction.type === 'SET_PRICE') {
          newOfferedTotal = reduction.value;
        }
        finalTotal = totalBuyBasePrice + newOfferedTotal + totalSupplements;
      }
    }

    return finalTotal;
  }

  calculatePromotionBaseTotal(): number {
    const promo = this.promo;
    const shouldInvert = this.shouldInvertCheapestOffered();

    let productsToPayFor: Array<{ product: any, quantity: number, rule: any }> = [];
    let productsToGetFree: Array<{ product: any, quantity: number, rule: any }> = [];

    if (shouldInvert) {
      productsToPayFor = this.getOfferedItems();
      productsToGetFree = this.getSelectedBuyItems();
    } else {
      productsToPayFor = this.getSelectedBuyItems();
      productsToGetFree = this.getOfferedItems();
    }

    let totalPayBaseItems = 0;
    productsToPayFor.forEach(item => {
      const basePrice = this.getProductBasePrice(item.product, item.rule);
      totalPayBaseItems += basePrice * item.quantity;
    });

    let totalFreeBaseItems = 0;
    productsToGetFree.forEach(item => {
      const basePrice = this.getProductBasePrice(item.product, item.rule);
      totalFreeBaseItems += basePrice * item.quantity;
    });

    const reduction = promo?.payload?.reduction;
    let promotionBaseTotal = totalPayBaseItems;

    if (reduction) {
      const cheapestBaseTotal = Math.min(totalPayBaseItems, totalFreeBaseItems);
      const mostExpensiveBaseTotal = Math.max(totalPayBaseItems, totalFreeBaseItems);

      if (reduction.type === 'PERCENTAGE') {
        const discount = cheapestBaseTotal * reduction.value;
        promotionBaseTotal = mostExpensiveBaseTotal + (cheapestBaseTotal - discount);
      } else if (reduction.type === 'FIXED_AMOUNT') {
        const discount = Math.min(reduction.value, cheapestBaseTotal);
        promotionBaseTotal = mostExpensiveBaseTotal + (cheapestBaseTotal - discount);
      } else if (reduction.type === 'SET_PRICE') {
        promotionBaseTotal = totalPayBaseItems + reduction.value;
      }
    }

    return this.truncate2(promotionBaseTotal);
  }

  getTotalReductionAmount(): number {
    const promo = this.promo;
    const reduction = promo?.payload?.reduction;

    if (!reduction) return 0;

    const totalOfferedBasePrice = this.getTotalOfferedPriceWithoutSupplements();

    if (reduction.type === 'PERCENTAGE') {
      return Math.round(totalOfferedBasePrice * reduction.value * 100) / 100;
    } else if (reduction.type === 'FIXED_AMOUNT') {
      return this.truncate2(Math.min(reduction.value, totalOfferedBasePrice));
    }

    return 0;
  }

  getTotalBeforeReduction(): number {
    const totalBuyBasePrice = this.getTotalBuyItemsPriceWithoutSupplements();
    const totalOfferedBasePrice = this.getTotalOfferedPriceWithoutSupplements();
    const totalSupplements = this.getTotalSupplementsPrice();

    return Number(totalBuyBasePrice + totalOfferedBasePrice + totalSupplements);
  }

  doesItemHaveReduction(ruleId: string, productId: string): boolean {
    const promo = this.promo;
    const reduction = promo?.payload?.reduction;
    const cheapestOffered = promo?.payload?.cheapestOffered;

    if (!reduction) return false;

    const rule = promo?.payload?.rules.find((r: any) => r.id === ruleId);
    if (!rule) return false;
    if (cheapestOffered) {
      return this.isProductInOfferedGroup(ruleId, productId);
    }
    return rule.offered;
  }

  // ✅ CORRECTION MÉTHODE CENTRALE D'AFFICHAGE DES PRIX EN VERT
  getItemDisplayPrice(ruleId: string, productId: string, index: number = 0): number {
    const promo = this.promo;
    const reduction = promo?.payload?.reduction;
    const basePrice = this.getItemBasePriceOnly(ruleId, productId, index);

    if (!reduction || reduction.type === 'FIXED_AMOUNT') {
      return basePrice;
    }

    if (reduction.type === 'PERCENTAGE') {
      if (!this.doesItemHaveReduction(ruleId, productId)) {
        return basePrice;
      }
      return Math.round(basePrice * (1 - reduction.value) * 100) / 100;
    }

    return basePrice;
  }

  shouldShowStrikethroughPrice(ruleId: string, productId: string): boolean {
    const promo = this.promo;
    const reduction = promo?.payload?.reduction;

    if (!reduction || reduction.type !== 'PERCENTAGE') {
      return false;
    }

    return this.doesItemHaveReduction(ruleId, productId);
  }

  shouldShowGreenPrice(ruleId: string, productId: string): boolean {
    const promo = this.promo;
    const reduction = promo?.payload?.reduction;

    if (!reduction || reduction.type !== 'PERCENTAGE') {
      return false;
    }

    return this.doesItemHaveReduction(ruleId, productId);
  }

  getReductionText(): string {
    const promo = this.promo;
    if (!promo?.payload?.reduction) return '';

    const reductionType = promo.payload.reduction.type;
    const reductionValue = promo.payload.reduction.value || 0;

    if (reductionType === 'PERCENTAGE') {
      const percentage = reductionValue * 100;
      return ` -${this.truncate2(percentage)}%`;
    } else if (reductionType === 'FIXED_AMOUNT') {
      return ` -${this.truncate2(reductionValue)}€`;
    }

    return '';
  }

  doesBuyItemsGroupHaveReduction(): boolean {
    const promo = this.promo;
    if (!promo?.payload?.reduction) return false;

    if (promo.payload.cheapestOffered) return false;

    const buyItems = this.getSelectedBuyItems();
    if (buyItems.length === 0) return false;
    return buyItems.some(item => this.doesItemHaveReduction(item.rule.id, item.product.id));
  }

  doesOfferedItemsGroupHaveReduction(): boolean {
    const promo = this.promo;
    if (!promo?.payload?.reduction) return false;

    if (promo.payload.cheapestOffered) {
      return this.getOfferedItems().length > 0;
    }
    const offeredItems = this.getOfferedItems();
    if (offeredItems.length === 0) return false;
    return offeredItems.some(item => this.doesItemHaveReduction(item.rule.id, item.product.id));
  }

  getFixedAmountReductionBadge(): string {
    const promo = this.promo;
    if (!promo?.payload?.reduction) return '';

    const reduction = promo.payload.reduction;
    if (reduction.type !== 'FIXED_AMOUNT') return '';

    return `-${reduction.value}€`;
  }

  addToCart() {
    if (!this.canAddToCart()) {
      this.notificationService.sendNotification(NotificationType.WARNING, this.getValidationMessage() || 'Veuillez compléter les sélections obligatoires', '');
      return;
    }
    const promo = this.promo;
    const shouldInvert = this.shouldInvertCheapestOffered();
    let buyItems = shouldInvert ? this.getOfferedItems() : this.getSelectedBuyItems();
    let offeredItems = shouldInvert ? this.getSelectedBuyItems() : this.getOfferedItems();
    const formattedCustomizedItems: { [key: string]: any } = {};

    const formatItems = (items: Array<{ product: any; quantity: number; rule: any }>) => {
      return items.map(item => {
        let totalBasePrice = 0;
        let totalSupplementsPrice = 0;
        for (let i = 0; i < item.quantity; i++) {
          totalBasePrice += this.getProductBasePrice(item.product, item.rule);
          totalSupplementsPrice += this.getCustomizationExtraPrice(item.rule.id, item.product.id, i);
          const baseKey = this.getItemKey(item.rule.id, item.product.id);
          const fullKey = `${baseKey}_${i}`;
          const customization = this.customizedItems[baseKey]?.[i];
          if (customization) formattedCustomizedItems[fullKey] = customization;
        }
        return {
          product: item.product, quantity: item.quantity, rule: item.rule,
          unitBasePrice: totalBasePrice / item.quantity,
          unitSupplementsPrice: totalSupplementsPrice / item.quantity,
          unitPrice: (totalBasePrice + totalSupplementsPrice) / item.quantity,
          totalBasePrice, totalSupplementsPrice,
          totalPrice: totalBasePrice + totalSupplementsPrice
        };
      });
    };

    const formattedBuyItems = formatItems(buyItems);
    const formattedOfferedItems = formatItems(offeredItems);
    const totalSupplementsPrice = this.getTotalSupplementsPrice();
    const promotionTotal = this.truncate2(this.calculatePromotionBaseTotal() + totalSupplementsPrice);

    this.cartService.addPromotion({
      promotion: {
        ...this.promo, addedByPromoCode: true,
        promoCode: this.data.promoCode || '',
        payload: {
          ...this.promo.payload, invertedDueToCheapestOffered: shouldInvert,
          promotionBaseTotal: this.calculatePromotionBaseTotal(), totalSupplementsPrice
        }
      },
      promotionImage: this.promo.image || '',
      buyItems: formattedBuyItems,
      offeredItems: formattedOfferedItems,
      customizedItems: formattedCustomizedItems,
      total: promotionTotal
    });

    this.notificationService.sendNotification(NotificationType.SUCCESS, `Promotion ajoutée au panier! Total: ${promotionTotal.toFixed(2)}€`, '');
    this.bottomSheet.dismiss();
    this.dialogRef.close('added');
  }

  cancel() {
    this.bottomSheet.dismiss();
    this.dialogRef.close();
  }
}
